module.exports = __webpack_public_path__ + "img/testETH.26d4af6c.svg";